import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Empty, Input, Popover, Select, Table, Tabs, Modal } from "antd"
import { useContext, useEffect, useState } from "react";
import { Dropdown, Icon, TabPane } from "semantic-ui-react";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb"
import { ModalExportarDatosJurado } from "../../../components/Jurados/ExportarDatosJurado";
import { useBancoJurado } from "../../../hooks/useBancoJurado";
import { useMaestras } from "../../../hooks/useMaestras";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ModalVerMasJurado } from "./ModalVerMasJurado";
import { TemplateContext } from "../../../utils/template_context";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import getStorageUser from "../../../middlewares/GetStorageUser"

export const BancoJurado = () => {

  const {
    obtenerJurados,
    jurados,
    totalBancoJurados,
    loadingJurados,
    handleAreaChange,
    categorias,
    filtros,
    setFiltros,
    buscarFiltros,
    limpiarFiltros
  } = useBancoJurado();

  const context = useContext(TemplateContext);
  const [activeKey, set_activeKey] = useState<string>('1');
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [user, setUser] = useState<any>({});

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const coloresEstado: any = {
    "Sin Revisar": "black",
    Aceptado: "#00904C",
    Rechazado: "#DB2828",
    Subsanar: "#F28C02",
    Subsanado: "#6435C9",
    "Anulado": "#0051E6",
    "Evaluado": "#6435C9",
    "Por evaluar": "#F28C02",
    "Aceptó": "#00904C",
  };

  interface PostulacionModel {
    id_postulacion: number;
    convocatoria_id: number;
    numero_documento_participante: number;
    nombre_propuesta: string;
    nombre_participante: string;
    jurados: Array<Object>;
    estado_jurado: boolean;
    fecha_creacion: string;
    tipo_participante: string;
    links: Array<Object>;
    nombre_convocatoria: string;
    categoria_linea_convocatoria: Array<Object>;
    fecha_apertura: string;
    fecha_actualizacion: string;
    particiapnte: Array<Object>;
    estado: string;
    documentos_generales: Array<Object>;
    documentos_tecnicos: Array<any>;
    documentos_administrativos: any;
    linea_convocatoria: number;
    radicado: string;
    pasos: {
      personales: boolean,
      categorias: boolean,
      administrativos: boolean,
      tecnicos: boolean,
      links: boolean
    };
  }
  const initialValuesPostulacionModel = {
    id_postulacion: 0,
    convocatoria_id: 0,
    numero_documento_participante: 0,
    nombre_propuesta: "",
    nombre_participante: "",
    jurados: [],
    estado_jurado: false,
    fecha_creacion: "",
    tipo_participante: "",
    links: [],
    nombre_convocatoria: "",
    categoria_linea_convocatoria: [],
    fecha_apertura: "",
    fecha_actualizacion: "",
    particiapnte: [],
    estado: "",
    documentos_generales: [],
    documentos_tecnicos: [],
    documentos_administrativos: [],
    linea_convocatoria: 0,
    radicado: "",
    pasos: {
      personales: true,
      categorias: false,
      administrativos: false,
      tecnicos: false,
      links: false
    }
  };
  const [postulacionEditar, setPostulacionEditar] = useState<PostulacionModel>(initialValuesPostulacionModel);
  const validateFormsCompleted = (datos) => {
      //Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
      setPostulacionEditar(datos);
      //setModalEditar(true);
  }
  const showModal2 = () => {
    setIsModalOpen2(true);
  };
  const handleOk2 = () => {
    setIsModalOpen2(false);
  };
  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };
  const guardar = async (datos?: any) => {
    try {
        console.log(datos)
        await apiParticipantes.eliminarPostulacionRadicado(datos.radicado, datos.numero_documento);
      } catch (error) {
        console.log(error)
    }
    window.location.reload();
  }

  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <span>{index + 1}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },

    {
      title: "Nombre y apellido",
      width: 200,
      render: (datos: any) => {
        return (
          <>
            {datos.primer_nombre} {datos.segundo_nombre} {datos.primer_apellido} {datos.segundo_apellido}
          </>
        );
      },

    },
    {
      title: "Nro documento",
      width: 140,
      dataIndex: "numero_documento",
      key: "numero_documento",
    },
    {
      title: "Código",
      width: 120,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Estado",
      width: 120,
      dataIndex: "status",
      key: "status",
      render: (statusValue: string, record: any, index: number) => {
        return (
          <>
            {statusValue === 'Sin verificar' ? (
              <div>
                <span style={{ color: coloresEstado[statusValue] }}>Inscrito sin revisar</span>
              </div>
            ) : statusValue === 'Aceptó' ? (
              <div>
                <span style={{ color: coloresEstado[statusValue] }}>En estudio</span>
              </div>
            ) : (
              <div>
                <span style={{ color: coloresEstado[statusValue] }}>{statusValue}</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Fecha de creación",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span>{datos.fecha_creacion}</span>
          </>
        );
      },
    },
    {
      title: "Área",
      width: 169,
      render: (datos: any) => {
        return <div>{datos.area !== null && datos.area ? datos.area : 'Este jurado no tiene áreas'}</div>
      },
    },
    {
          title: "Categorías",
          width: 169,
          ellipsize: true,
          render: (datos: any) => {
            // Si areas_conocimientos es null, utiliza categorias_area
            const categorias = datos?.areas_conocimientos
              ? datos?.areas_conocimientos.flatMap((conocimientos: any) =>
                  conocimientos?.areas_conocimientos.map(
                    (datos_conocimientos: any) => datos_conocimientos?.nombre
                  )
                )
              : JSON.parse(datos?.categorias_area || "[]").map(
                  (categoria: any) => categoria?.nombre
                );
            const content = (
              <ul>
                {categorias.map((nombre: string, index: number) => (
                  <li
                    key={index}
                    className="font-family-Monserrat-Regular font-size-11px"
                  >
                    {nombre}
                  </li>
                ))}
              </ul>
            );
    
            const firstCategory = categorias[0] || "Sin categoría";
    
            return (
              <>
                <Popover content={content} title="Categorías">
                  {firstCategory.length > 27
                    ? `${firstCategory.substring(0, 24)}...`
                    : firstCategory}
                </Popover>
              </>
            );
          },
        },

    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <>
          <div className="justify-content-center">
            <div>
              <a className="button-azul-ghost" onClick={() => openModalVerMas(datos)}>Ver más</a>
            </div>
          </div>
          {
            user.role_id == 1 &&
            <div className="col-12 justify-content-center">
              <div>
                <a className="button-azul-ghost"
                  onClick={() => {
                    console.log(datos)
                    showModal2();
                    validateFormsCompleted(datos);
                  }}>
                    Anular
                </a>
              </div>
            </div>
            }
        </>
      ),
    },
  ];

  const columnsPostulaciones: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },

    {
      title: "Nombre y apellido",
      width: 200,
      render: (datos: any) => {
        return (
          <>
            {datos.primer_nombre} {datos.segundo_nombre} {datos.primer_apellido} {datos.segundo_apellido}
          </>
        );
      },

    },
    {
      title: "Nro documento",
      width: 140,
      dataIndex: "numero_documento",
      key: "numero_documento",
    },
    {
      title: "Código",
      width: 120,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Estado",
      width: 120,
      dataIndex: "status",
      key: "status",
    },
    /*{
      title: "Categorías",
      width: 169,
      ellipsize: true,

      render: (datos: any) => {
        const content = (
          <ul>
            {datos?.categorias?.map((categoria: any, i) =>
              (<li key={i} className="font-family-Monserrat-Regular font-size-11px">{categoria?.nombre}</li>)
            )
            }
          </ul>
        );

        return (
          <>
            {datos?.categorias !== undefined ?
              <Popover content={content} title="Categorías">
                {datos?.categorias[0]?.nombre.length > 27 ? `${datos?.categorias[0]?.nombre.substring(0, 24)}...` : `${datos?.categorias[0]?.nombre}...`}
              </Popover>
              : "-"
            }
          </>
        );
      },
    },*/

    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <div className="justify-content-center">
          <div>
            <a className="button-azul-ghost" onClick={() => openModalVerMas(datos)}>Ver más</a>
          </div>
        </div>
      ),
    },
  ];

  const { obtenerAreas, areas } = useMaestras();

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      obtenerAreas();
    }
    return () => {
      mounted = false;
    }
  }, [activeKey])


  function callback(key) {
    set_activeKey(key);
  }


  const routes = [{ nombre: "Postulaciones" }, { nombre: "Banco de jurados" }];

  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  };

  const [idJurado, setIdJurado] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [radicado, setRadicado] = useState('');
  const [numero_documento, setNumero_documento] = useState('');
  const [estado, setEstado] = useState();
  const [idPostulacion, setIdPostulacion] = useState(0)
  const [observaciones, setObservaciones] = useState();
  const [areaPrincipal, setAreaPrincipal] = useState('')

  const openModalVerMas = (jurado: any) => {
    setAreaPrincipal(jurado.area);
    setIdJurado(jurado.id_jurado);
    setOpenModal(true);
    setRadicado(jurado.radicado)
    setObservaciones(jurado.observaciones);
    setEstado(jurado.status)
    setIdPostulacion(jurado.id_postulacion)
    setNumero_documento(jurado.numero_documento)
  }

  return (
    <>
      <div className="background-color-F7FBFF h-100">
        <BreadCrumbAdmin routes={routes} />
        <div className="container-fluid ps-md-4 pe-md-4 main-c">


          <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
            Banco de jurados
          </div>

          <div className="sombra_card" style={{ marginBottom: "20px" }}>
            <div>

              <div
                className="header_card"
              >
                <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">Filtrar jurados</div>
              </div>
              <div className="body_card">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div>
                      <div className="col-12">
                        <span>Filtrar por palabra clave</span>
                      </div>
                      <div className="col-12">
                        <Input value={filtros.palabra_clave} onChange={(e) => setFiltros({ ...filtros, palabra_clave: e.target.value })} placeholder="Buscar..." suffix={<SearchOutlined className="font-color-051923bf" />} />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="row">
                      <div>
                        <span>Filtrar área</span>
                      </div>
                      <div>
                        <Select size="large" value={filtros.area} style={{ width: "100%" }} placeholder="Seleccionar..." onChange={handleAreaChange} >
                          {areas.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={`${id}.${nombre}`}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="row">
                      <div>
                        <span>Filtrar categoría</span>
                      </div>
                      <div>
                        <Select size="large" value={filtros.categoria} style={{ width: "100%" }} placeholder="Seleccionar..." onChange={(v) => setFiltros({ ...filtros, categoria: v })}>
                          {categorias.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="row">
                      <div className="col-12">
                        <span>Filtrar estado</span>
                      </div>
                      <div className="col-12">
                        <Select size="large" value={filtros.estado} style={{ width: "100%" }} placeholder="Seleccionar..." onChange={(e) => setFiltros({ ...filtros, estado: e })}>
                          <Select.Option value="Aceptó">Aceptó</Select.Option>
                          <Select.Option value="No aceptó">No aceptó</Select.Option>
                          <Select.Option value="No responde">No responde</Select.Option>
                          <Select.Option value="Rechazó">Rechazó</Select.Option>
                          <Select.Option value="Postulado">Postulado</Select.Option>
                          <Select.Option value="Sin verificar">Sin verificar</Select.Option>
                        </Select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <div className="footer_card justify-content-flex-end">
                <Button className="button-azul-ghost m-0" onClick={() => activeKey === "1" ? limpiarFiltros('bancojurados') : limpiarFiltros('postulaciones')}>
                  Limpiar filtros
                </Button>
                <Button className="button-azul-radius m-0" onClick={buscarFiltros}>
                  Buscar
                </Button>
              </div>


            </div>
          </div>

          <div className="row-shadow" style={{ marginBottom: "6%", marginTop: "16px" }}>
            <div className="col-12">

              <div
                className="font-size-14px font-color-1B1C1D font-family-Montserrat-Regular border-bottom pt-0 pb-2 mb-3"
              >
                Lista de jurados
              </div>


              <div className="row">
                <div className="col-12">
                  <Tabs defaultActiveKey="1" onChange={callback}>
                    <TabPane tab="Banco jurados" key="1">
                      <div className="d-flex justify-content-end align-content-center align-items-center mb-3">
                        <div>
                          Total: <span className="font-color-F28C02">{totalBancoJurados}</span>
                        </div>
                        <div className="d-flex registos-adminconvocatoria" style={{ width: 200 }}>
                          <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                            Registros por página
                          </label>
                          <Dropdown
                            className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                            options={cantidadRegistros}
                            icon={<Icon className="font-color-051923bf iconos-dropdown-global" name="angle down" />}
                          />
                        </div>

                      </div>
                      <Table
                        style={{ borderTop: "1px solid #C4C4C4" }}
                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                        pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: 10 }}
                        dataSource={jurados}
                        columns={columns}
                        size="small"
                        bordered={false}
                        loading={loadingJurados}
                      />
                    </TabPane>
                    <TabPane tab="Postulaciones" key="2">
                      <div className="d-flex justify-content-end align-content-center align-items-center mb-3">
                        <div>
                          Total: <span className="font-color-F28C02">{totalBancoJurados}</span>
                        </div>
                        <div className="d-flex registos-adminconvocatoria" style={{ width: 200 }}>
                          <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                            Registros por página
                          </label>
                          <Dropdown
                            className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                            options={cantidadRegistros}
                            icon={<Icon className="font-color-051923bf iconos-dropdown-global" name="angle down" />}
                          />
                        </div>

                      </div>
                      <Table
                        style={{ borderTop: "1px solid #C4C4C4" }}
                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                        pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: 10 }}
                        dataSource={jurados.filter((x: any) => x.status == 'Postulado' || x.status == 'Aceptó' || x.status == "No aceptó" || x.status == "No responde")}
                        columns={columnsPostulaciones}
                        size="small"
                        bordered={false}
                        loading={loadingJurados}
                      />
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: '100%' }}>
        <div className="container-sticky-footer" style={{ padding: 20 }}>
          <div className="justify-content-flex-end">
            <ModalExportarDatosJurado />
          </div>
        </div>
      </div>

      {openModal &&
        <ModalVerMasJurado
          openModal={openModal}
          setOpenModal={setOpenModal}
          idJurado={idJurado}
          radicado={radicado}
          observaciones={observaciones}
          estado={estado}
          tipoPostulacion={activeKey === "1" ? 'bancojurados' : 'postulaciones'}
          setEstado={setEstado}
          idPostulacion={idPostulacion}
          obtenerJurados={obtenerJurados}
          areaPrincipal={areaPrincipal}
          docJurado={numero_documento}
          buscarFiltros={buscarFiltros}
        />
      }
      <Modal
          style={{ top: 120, zIndex: 3, background: "transparent" }}
          visible={isModalOpen2}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closeIcon="X"
          onOk={handleOk2}
          onCancel={handleCancel2}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa modal-formularios-completar"
        >
          {
            postulacionEditar ?
              <div>
                <div className="row-shadow">
                  <div className="row">
                    <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                      ¿Desea anular la postulación con radicado: {postulacionEditar.radicado}?
                    </div>
                    <div className="text-center col-12">
                      <Button className="button-gray-ghost" onClick={handleCancel2}>
                        CANCELAR
                      </Button>
                      <Button className="button-azul-radius" onClick={() => {
                        guardar(postulacionEditar);
                        handleOk2;
                        }}>
                        ACEPTAR
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              :
              <p>No se pudo cargar esta convocatoria</p>
          }
        </Modal>
    </>
  )
}
